import { offersListUpdated } from '@/events'

export function init () {
  offersListUpdated.subscribe((e, { offers } = e.detail) => {
    const hotelCodes = offers.map(offer => offer.Merlin_HotelCode)

    /* eslint-disable-next-line */
    window.criteo_static = window.criteo_static || []

    /* eslint-disable-next-line */
    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push.apply(window.criteo_q, window.criteo_static.concat({ event: 'viewList', item: hotelCodes }))
  })
}


// WEBPACK FOOTER //
// ./src/modules/criteo/criteoHotels.js